import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import styled from "styled-components";
import { RoundedButton } from "../../components/roundedButton";
import { WrapContainer } from "../../components/wrapContainer";
import { useNoleggioUsatoQuery } from "../../generated/graphql";

// Reuse the Contentful cover image pattern already used on other top-level pages.
const ImgBanner = styled.img`
  width: 100%;
  height: auto;
`;

const Container = styled.div`
  width: 100%;
  max-width: var(--page-max-width);
  padding: 4em 0;
  box-sizing: border-box;
`;

const Hero = styled.section`
  max-width: 900px;
  margin-bottom: 3em;

  h1 {
    margin: 0 0 0.4em;
    font-size: clamp(2rem, 4vw, 4rem);
    line-height: 1;
    text-transform: uppercase;
  }

  h2 {
    margin: 0;
    max-width: 760px;
    color: #333;
    font-size: 1.15rem;
    font-weight: 400;
    line-height: 1.6;
  }
`;

const Content = styled.section`
  max-width: 1000px;
  font-size: 1.05rem;
  line-height: 1.7;

  h1,
  h2,
  h3 {
    line-height: 1.2;
  }

  ul,
  ol {
    padding-left: 1.4em;
  }

  a {
    color: #be1522;
    font-weight: 700;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 2em;
`;

export function NoleggioUsato() {
  const [{ data }] = useNoleggioUsatoQuery();
  const content = data?.noleggioUsatoCollection?.items[0];

  return (
    <>
      {content?.copertina?.url && <ImgBanner src={content.copertina.url} />}
      <WrapContainer grey>
        <Container>
          <Hero>
            <h1>{content?.titolo || "Noleggio usato"}</h1>
            {content?.descrizione && <h2>{content.descrizione}</h2>}
          </Hero>

          <Content>
            {documentToReactComponents(content?.macchine?.json)}
          </Content>

          <ButtonContainer>
            <a href="/preventivo">
              <RoundedButton className="solid">
                RICHIEDI UN PREVENTIVO
              </RoundedButton>
            </a>
          </ButtonContainer>
        </Container>
      </WrapContainer>
    </>
  );
}
